import type {
  mutationAddTagsForRentals,
  mutationAddTagsForRentalsVariables,
} from 'Constants/graphql/mutations/__generated__/mutationAddTagsForRentals'
import type {
  mutationRemoveTagsForRentals,
  mutationRemoveTagsForRentalsVariables,
} from 'Constants/graphql/mutations/__generated__/mutationRemoveTagsForRentals'
import { MUTATION_ADD_TAGS_FOR_RENTALS } from 'Constants/graphql/mutations/MutationAddTagsForRentals'
import { MUTATION_REMOVE_TAGS_FOR_RENTALS } from 'Constants/graphql/mutations/MutationRemoveTagsForRentals'

import { TAG_COLOR } from 'Portal/__generated__/globalTypes'

import type { TagColor } from './tagging.types'
import { normalizeTagColor } from './tagging.utils'
import type { TaggingEntityAdapter } from './taggingEntityAdapter.types'

export const rentalTaggingAdapter = {
  add: {
    document: MUTATION_ADD_TAGS_FOR_RENTALS,
    getAffectedEntityIds: (data: mutationAddTagsForRentals) =>
      Array.from(
        new Set(
          (data.addTagsForRentals.items ?? []).map(item =>
            String(item.taggable_id),
          ),
        ),
      ),
    operationName: 'addTagsForRentals',
    toVariables: ({ color, entityIds, name, orgId }) => ({
      input: {
        orgID: orgId,
        rentalIDs: entityIds,
        tags: [{ color: TAG_COLOR[normalizeTagColor(color)], name }],
      },
    }),
  },
  getTagsFromHit: hit =>
    (hit['rental.tags'] ?? []).map(tag => ({
      // Typesense stores this as a string rather than the GraphQL TAG_COLOR enum.
      color: tag.color as TagColor,
      id: String(tag.id),
      name: tag.name,
    })),
  messages: {
    addError: 'Tags_add_error',
    added: 'Tags_added',
    applyingToCount: 'Tags_applying_to_count',
    removeError: 'Tags_remove_error',
    removed: 'Tags_removed',
  },
  remove: {
    document: MUTATION_REMOVE_TAGS_FOR_RENTALS,
    operationName: 'removeTagsForRentals',
    toVariables: ({ entityIds, orgId, tagIds }) => ({
      input: {
        orgID: orgId,
        rentalIDs: entityIds,
        tagIDs: tagIds,
      },
    }),
  },
  scopeSelector: '.RentalTagsRow',
} satisfies TaggingEntityAdapter<
  mutationAddTagsForRentals,
  mutationAddTagsForRentalsVariables,
  mutationRemoveTagsForRentals,
  mutationRemoveTagsForRentalsVariables
>
